/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodSadDizzy = createReactComponent("mood-sad-dizzy", "IconMoodSadDizzy", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0", key: "svg-1" }],
  ["path", { d: "M8 9l2 2", key: "svg-2" }],
  ["path", { d: "M10 9l-2 2", key: "svg-3" }],
  ["path", { d: "M14 9l2 2", key: "svg-4" }],
  ["path", { d: "M16 9l-2 2", key: "svg-5" }]
]);

export { IconMoodSadDizzy as default };
//# sourceMappingURL=IconMoodSadDizzy.js.map
